'use client';

import { ReactElement } from 'react';
import { Icon } from '@nx-frontend/shared/ui/icon';

interface ActivityIconProps {
  background: string;
  icon: ReactElement;
  iconColor: string;
  borderColor: string;
}

export function ActivityIcon({ background, icon, iconColor, borderColor }: ActivityIconProps) {
  return (
    <div
      className="flex items-center justify-center w-5 h-5 rounded-full absolute -bottom-1 -right-1 "
      style={{ backgroundColor: background, border: `1px solid ${borderColor}` }}
    >
      <Icon icon={icon} className={iconColor} />
    </div>
  );
}
